import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    ListarPorConvenio: async (pIdConvenio: number) => {
        const response = await httpClient.get(`/Convenio/tabela?pIdConvenio=${pIdConvenio}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ListarPorId: async (pIdConvenio: number) => {
        const response = await httpClient.get(`/Convenio/id?id=${pIdConvenio}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
});